export function formatNumber(value) {
    if (value >= 1e9) {
        return `${Math.floor(value / 1e9)}B`;
    }

    if (value >= 1e6) {
        return `${Math.floor(value / 1e6)}M`;
    }

    if (value >= 1e3) {
        return `${Math.floor(value / 1e3)}k`;
    }

    return `${Math.floor(value)}`;
}


const numberFormat = (window.Intl && window.Intl.NumberFormat)
    ? new window.Intl.NumberFormat()
    : null;

export function formatInteger(value) {
    return numberFormat
        ? numberFormat.format(value)
        : Math.floor(value).toString();
}


const dateFormat = (window.Intl && window.Intl.DateTimeFormat)
    ? new window.Intl.DateTimeFormat()
    : null;

export function formatDate(date) {
    if (dateFormat) {
        return dateFormat.format(Number(date));
    }
    const d = new Date(+date);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
}
